
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { PurchaseAbstractApi } from '../api/purchase-abstract.api';
import { switchMap, map } from 'rxjs/operators';
import { PurchaseAbstractData, PurchaseAbstract } from '../../../interfaces/masters/purchase-abstract';

@Injectable()
export class PurchaseAbstractService extends PurchaseAbstractData {

  constructor(private api: PurchaseAbstractApi) {
    super();
  }



  list(url: string): Observable<PurchaseAbstract[]> {
    return this.api.list(url);
  }

  getById(url:string): Observable<PurchaseAbstract>{
      return this.api.getById(url);
  }

  create(url: string, data:PurchaseAbstract): Observable<PurchaseAbstract> {
    return this.api.add(url,data);
  }

  update(url: string, data:PurchaseAbstract): Observable<PurchaseAbstract> {
    return this.api.update(url,data);
  }
  searchList(url: string,data:any): Observable<any> {
     
    return this.api.searchList(url,data);
  }


  delete(url: string): Observable<boolean> {
    return this.api.delete(url);
  }
}
